import React, { useEffect, useState, useRef } from "react";
import { Typography } from "@mhome/ui";
import { SyncBadge } from "../../common/badges";
import BrightnessBar from "../common/brightness-bar";

const BrightnessDetail1Widget = ({ widget, onValueUpdate, pattern }) => {
  const [brightness, setBrightness] = useState(0);
  const [minMax, setMinMax] = useState({ min: 0, max: 100 });
  const lastValueRef = useRef(null);

  useEffect(() => {
    if (widget?.items?.$w1) {
      const initialValue = Number(widget.items.$w1.value);
      const validValue = isNaN(initialValue) ? 0 : initialValue;
      setMinMax({
        min: widget.items.$w1.min ?? 0,
        max: widget.items.$w1.max ?? 100,
      });
      setBrightness(validValue);
      lastValueRef.current = validValue;
    }
  }, [widget]);

  const handleValueUpdate = (data) => {
    if (data === lastValueRef.current) return;
    console.debug("brightness detail data", data);
    const updatedWidget = {
      ...widget.items.$w1,
      value: data,
    };
    lastValueRef.current = data;
    onValueUpdate(updatedWidget);
  };

  const handleBrightnessChange = (event, newValue) => {
    if (pattern && pattern.endsWith("_R")) return;
    event.stopPropagation();
    const adjustedValue = Math.min(Math.max(newValue, minMax.min), minMax.max);
    setBrightness(adjustedValue);
  };

  const disabled = pattern && pattern.endsWith("_R");

  return (
    <div className="w-full flex flex-col gap-4">
      {pattern && pattern.endsWith("_W") && (
        <div className="flex justify-end">
          <SyncBadge />
        </div>
      )}

      {/* Brightness Status Card */}
      <div
        className="rounded-2xl px-3 py-1.5 flex items-center justify-between"
        style={{
          height: "40px",
          backgroundColor: "hsl(var(--primary))",
        }}
      >
        <Typography className="text-white font-bold text-lg">
          {brightness}%
        </Typography>
        <div className="h-8 aspect-square flex items-center justify-center flex-shrink-0">
          <span className="text-white font-bold text-xl">☀</span>
        </div>
      </div>

      {/* Brightness Control */}
      <div className="h-12">
        <BrightnessBar
          value={brightness}
          onChange={handleBrightnessChange}
          disabled={disabled}
          onValueUpdate={handleValueUpdate}
          min={minMax.min}
          max={minMax.max}
          showLevel={true}
          showText="Brightness"
        />
      </div>
    </div>
  );
};

export default BrightnessDetail1Widget;
